// extracted by mini-css-extract-plugin
export default {"clients":"Clients_clients__5WEyq","title":"Clients_title__Id5kG","table":"Clients_table__D4zOg","pointer":"Clients_pointer__55mJy"};